import React, { useState } from "react";
import novaLogo from "../../assets/images/novaLogoMain.png";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { toast } from "react-toastify";
import {
  getFetcher,
  postFetcherForLogin,
} from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { useLanguage } from "../../context/LanguageContext";
// import { MdClose } from "react-icons/md";

const LoginPopUp: React.FC = () => {
  const { t } = useLanguage();
  const { falseShowLoginPopup, setUser } = useUser();

  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<{ email?: string; password?: string }>(
    {}
  );

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors: { email?: string; password?: string } = {};

    if (!validateEmail(email)) {
      newErrors.email = "Error";
    }

    if (password.length < 6) {
      newErrors.password = "Error";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const result = await postFetcherForLogin(endpoints.auth.login, {
          arg: {
            email,
            password,
          },
        });

        if (typeof result === "string") {
          toast.error(t('toastMessage', 'login1'));
        } else {
          toast.success(t('toastMessage', 'login'), {
            hideProgressBar: true,
          });
          //FETCH USER INFO
          const fetchUserInfo = await getFetcher(
            endpoints.user.getUserByEmail.replace("{email}", email || "")
          );
          setUser(fetchUserInfo.user);
          localStorage.removeItem('defaultUserId');
          localStorage.removeItem('basketItems');
          setTimeout(() => {
            falseShowLoginPopup();
            window.location.reload();
        }, 1000);
        }
      } catch (error) {
        console.log(error);
        toast.error(t('toastMessage', 'login2'));
      }
    }
  };

  const handleClickClosePopUp = () => {
    falseShowLoginPopup();
  };
  
  const handleClickRegister = () => {
    navigate("/register");
    falseShowLoginPopup();
  }

  return (
    <div className=" w-9/12 md:w-2/5 xl:w-1/4  rounded-2xl shadow-black bg-white h-[520px] shadow-2xl right-4 lg:right-20 top-20 lg:top-32   z-50 fixed inset-0 ml-auto">
      <div className=" flex flex-col gap-y-7 p-8">
        {/* logo */}
        <div className=" flex justify-center w-full">
          <img
            className=" w-full mx-auto ml-10"
            src={novaLogo}
            alt="novaLogo"
          />

          <div className="-mt-6 -ml-6">
            <span
              onClick={handleClickClosePopUp}
              className=" cursor-pointer font-semibold hover:text-red-600 transition-all"
            >
              x
            </span>
          </div>
        </div>
        {/* title */}
        <div className=" flex justify-center flex-col items-center gap-y-2">
          <p className=" font-bold text-lg">{t('login', 'title')}</p>
          <p className="text-[#9794AA] font-light text-sm ">
          {t('login', 'text1')} 
          </p>
        </div>

        {/* inputs */}
        <div className="">
          <form className="flex flex-col gap-y-5">
            {/* Email Input */}
            <div>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`border w-full rounded-lg px-4 py-2 outline-none ${
                  errors.email ? "border-red-500" : "border-gray-400"
                }`}
                placeholder="Email"
              />
              {errors.email && (
                <span className="text-xs text-red-500 mt-1 block">
                  {errors.email}
                </span>
              )}
            </div>

            {/* Password Input */}
            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`border w-full rounded-lg px-4 py-2 outline-none ${
                  errors.password ? "border-red-500" : "border-gray-400"
                }`}
                placeholder={t('login', 'pass')} 
              />
              <span
                onClick={togglePasswordVisibility}
                className={`absolute right-3 ${
                  errors?.password ? "top-[33%]" : "top-1/2"
                } transform -translate-y-1/2 cursor-pointer text-gray-600`}
              >
                {showPassword ? <HiEye size={18} /> : <HiEyeOff size={18} />}
              </span>
              {errors.password && (
                <span className="text-xs text-red-500 mt-1 block">
                  {errors.password}
                </span>
              )}
            </div>

            {/* Remember Me & Forgot Password */}
            <div className="mt-4 ml-1 flex justify-between">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="mr-2"
                />
                <label
                  htmlFor="rememberMe"
                  className="text-xs text-[#CBCAD7] font-semibold cursor-pointer"
                >
                  {t('login', 'remember')} 
                </label>
              </div>

              <div className="mr-1">
                <button
                  type="button"
                  className="font-semibold text-xs hover:underline transition-all"
                  onClick={() => navigate("/forgot-password")}
                >
                  {t('login', 'fargotPass')}
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* button */}
        <div className=" flex flex-col items-center gap-y-5">
          <button
            onClick={handleSubmit}
            className=" bg-yellow-color w-full p-2 rounded-lg font-semibold active:scale-90 transition-transform"
          >
            {t('login', 'button')}
          </button>
          <div className=" flex gap-x-2 text-sm">
            <p className="text-[#666666]">{t('login', 'account')}</p>
            <button
              onClick={handleClickRegister}
              className=" font-semibold underline"
            >
              {t('login', 'register')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPopUp;
